"use client";

import { createContext } from 'react';

export const UserContext = createContext();
const UserContextProvider = ({user, children }) => {
    return (
        <UserContext.Provider value={{ user }}>
            {children}
        </UserContext.Provider>
    );
}

export default UserContextProvider;